import { Diversity3 as Diversity3Icon } from '@mui/icons-material'
import React from 'react'
import { T } from '@/helpers/T'
import { useGlobalShareholder } from '@/hooks/useGlobalShareholder'
import { useRoles } from '@/hooks/useRoles'
import { ShareholderTypeChip } from '@/modules/Shareholder/ShareholderTypeChip'
import { SHAREHOLDER_ROLES } from '@/utils/authorities'
import { NavbarContextSelector } from './NavbarContextSelector'

const NavbarGlobalShareholderInternal: React.FC = () => {
  const { hasAuthority } = useRoles()
  const { links, current, change } = useGlobalShareholder()

  if (!SHAREHOLDER_ROLES.some((role) => hasAuthority(role))) {
    return null
  }

  if (links.length === 0) {
    return null
  }

  const items = links.map((link) => ({
    entity: link.entity,
    logo: link.entityLogo,
    trailing: <ShareholderTypeChip membershipType={link.membershipType} />,
  }))
  const label = current?.eapcID ?? current?.fullName ?? ''

  return (
    <NavbarContextSelector
      icon={<Diversity3Icon fontSize='small' />}
      label={label}
      emptyLabel={<T id='c.global_shareholder.select' />}
      menuHeader={<T id='c.global_shareholder.menu_header' />}
      items={items}
      currentId={current?.id}
      onSelect={change}
    />
  )
}

export const NavbarGlobalShareholder = React.memo(
  NavbarGlobalShareholderInternal,
) as typeof NavbarGlobalShareholderInternal
